import client from './client';
import { UserInvitationRequest, UserInvitationResponse, AcceptInvitationRequest, InvitationInfo, AuthResponse } from '../types';

export const createInvitation = async (data: UserInvitationRequest, token: string): Promise<UserInvitationResponse> => {
  const response = await client.authenticatedPost('/api/v1/invitations/create', data);
  return response.json();
};

export const listInvitations = async (token: string, skip: number = 0, limit: number = 100): Promise<{
  invitations: InvitationInfo[];
  total_count: number;
  skip: number;
  limit: number;
}> => {
  const response = await client.authenticatedGet(`/api/v1/invitations/list?skip=${skip}&limit=${limit}`);
  return response.json();
};

export const getInvitationInfo = async (token: string): Promise<InvitationInfo> => {
  const response = await client.request(`/api/v1/invitations/info/${token}`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' }
  });
  return response.json();
};

export const acceptInvitation = async (data: AcceptInvitationRequest): Promise<AuthResponse> => {
  const response = await client.request('/api/v1/invitations/accept', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  });
  return response.json();
};

export const cancelInvitation = async (invitationId: string, token: string): Promise<{ success: boolean; message: string }> => {
  const response = await client.authenticatedDelete(`/api/v1/invitations/cancel/${invitationId}`);
  return response.json();
};

export const bulkUploadInvitations = async (file: File, dryRun: boolean, token: string): Promise<{
  success: boolean;
  dry_run: boolean;
  processed: number;
  created: number;
  skipped_existing_invites: number;
  skipped_existing_users: number;
  errors: Array<{ row: number; email?: string; error: string }>;
}> => {
  const form = new FormData();
  form.append('file', file);
  form.append('dry_run', String(dryRun ? 'true' : 'false'));
  const response = await client.authenticatedRequest('/api/v1/invitations/bulk-upload', {
    method: 'POST',
    body: form,
  });
  const data = await response.json();
  return data;
};